import React, { useEffect, useState, useContext } from "react";
import "./Features.css";

import feature1Video from "../../../../assets/images/mhero1/specialfeatures/crab.mp4";
import feature2Video from "../../../../assets/images/mhero1/specialfeatures/fordingDepth.mp4";
import feature3Video from "../../../../assets/images/mhero1/specialfeatures/unstopabletraction.mp4";
import feature4Video from "../../../../assets/images/mhero1/specialfeatures/others.mp4";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const HARDCODED_MEDIA = [
  { media: feature1Video, isVideo: true },
  { media: feature2Video, isVideo: true },
  { media: feature3Video, isVideo: true },
  { media: feature4Video, isVideo: true },
];

const FALLBACK_TAB_TITLES = [
  "Crab Walk",
  "Fording Depth",
  "Unstoppable Traction",
  "Other",
];

const buildFeatureItems = (features, featureTabs) => {
  const items = HARDCODED_MEDIA.map((item, index) => {
    const n = index + 1;
    const title =
      featureTabs?.[`tab_${n}`] ||
      features?.[`feature_${n}_title`] ||
      FALLBACK_TAB_TITLES[index] ||
      "";

    return {
      ...item,
      title,
    };
  }).filter((item) => item.title);

  return items.length ? items : HARDCODED_MEDIA.map((item, index) => ({
    ...item,
    title: FALLBACK_TAB_TITLES[index],
  }));
};

const Features = () => {
  const { currentLang } = useContext(LanguageContext);

  const [features, setFeatures] = useState(null);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFeatures = async () => {
      try {
        setLoading(true);

        const response = await getPageContent("mhero1", currentLang);
        const sections = response.sections || {};
        const items = buildFeatureItems(
          sections.features,
          sections.feature_tabs
        );

        setFeatures({
          title: sections.features?.features_title || "Key Features",
          items,
        });
      } catch (err) {
        console.error("Failed to load MHERO1 features", err);
      } finally {
        setLoading(false);
      }
    };

    loadFeatures();
  }, [currentLang]);

  if (loading || !features) return null;

  const current = features.items[active];

  return (
    <section className="features">
      <h2 className="features-title">{features.title}</h2>
      <span className="features-line" />

      <div className="features-tabs">
        {features.items.map((item, index) => (
          <div
            key={index}
            className={`feature-tab ${active === index ? "active" : ""}`}
            onClick={() => setActive(index)}
          >
            <p>{item.title}</p>
          </div>
        ))}
      </div>

      <div className="features-media">
        {current.isVideo ? (
          <video
            key={active}
            src={current.media}
            className="features-media-video"
            aria-label={current.title}
            autoPlay
            muted
            loop
            playsInline
          />
        ) : (
          <img
            src={current.media}
            alt={current.title}
            className="features-media-image"
          />
        )}
      </div>
    </section>
  );
};

export default Features;
